import { Accordion, Square, AccordionItemProps } from 'tamagui'
import { HeroIcon } from './HeroIcon'
import { ReactNode, useState } from 'react'

interface IHeroAccordionProps extends AccordionItemProps {
  value: string
  children: ReactNode
  accordionTitle?: ReactNode
  defaultValue?: string
}

export function HeroAccordion({
  value,
  children,
  accordionTitle,
  defaultValue = '',
  ...extraProps
}: IHeroAccordionProps) {
  const [isActive, setIsActive] = useState(false)
  const iconColor = isActive ? '$accent' : '$icon-secondary'
  const backgroundColor = isActive ? '$bg-surface-pressed' : 'transparent'

  const handlePress = () => {
    setIsActive(true)
    setTimeout(() => {
      setIsActive(false)
    }, 350)
  }

  return (
    <Accordion
      overflow="hidden"
      width="100%"
      type="multiple"
      defaultValue={[defaultValue]}
    >
      <Accordion.Item value={value}>
        <Accordion.Trigger
          flexDirection="row"
          justifyContent="space-between"
          borderWidth={0}
          {...extraProps}
          bg="transparent"
          onPress={handlePress}
        >
          {({ open }: { open: boolean }) => (
            <>
              {accordionTitle}
              <Square
                testID="accordion-square"
                animation="quick"
                rotate={open ? '180deg' : '0deg'}
                size={28}
                borderRadius="$border-radius-md"
                backgroundColor={backgroundColor}
              >
                <HeroIcon
                  icon={['fal', 'chevron-down']}
                  size={16}
                  color={iconColor}
                />
              </Square>
            </>
          )}
        </Accordion.Trigger>
        <Accordion.HeightAnimator animation="medium">
          <Accordion.Content
            animation="medium"
            exitStyle={{ opacity: 0 }}
            padding={0}
          >
            {children}
          </Accordion.Content>
        </Accordion.HeightAnimator>
      </Accordion.Item>
    </Accordion>
  )
}
